import { api } from "./api";

export const getTeam = async () => {
    try{
        const response = await api.get("/team");
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar times:", error);
        return [];
    }
}

export const addToTeam = async (id: string, player: string) => {
    try{
        const {data} = await api.get(`/team/${id}/member/add/${player}`)
        return data;
    } catch (error) {
        console.error("Erro ao adicionar membro ao time:", error);
        return null;
    }
}